var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"containerRules"},[(_vm.orthographigFormation)?_c('RulesComponent',{attrs:{"orthographigFormation":_vm.orthographigFormation}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }